import { createContext, useContext } from "react";

/**
 * Thin Auth0 context module with no app/router/url imports.
 *
 * Storybook preview must import from here (not auth0Provider) so TurboSnap does
 * not treat every `urlPaths` / auth-stack change as a global `.storybook/preview`
 * dependency and disable TurboSnap for the whole build.
 *
 * Loose typing preserves the previous untyped `React.createContext()` behaviour
 * so existing `const { user } = useAuth0()` call sites keep typechecking.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches legacy untyped context
export type Auth0ContextValue = any;

export const Auth0Context = createContext<Auth0ContextValue>(undefined);

export const useAuth0 = (): Auth0ContextValue => useContext(Auth0Context);
